import { QuerySwitch } from 'components/QuerySwitch';
import { FetchTimeOffDataContext } from 'modals/TimeOffModal/contexts/FetchTimeOff.data.context';
import { DeleteTimeOffViewPropsProvider } from 'modals/TimeOffModal/views/DeleteTimeOffView/DeleteTimeOffView.props.context';
import { FC } from 'react';
import { DeleteTimeOffViewComponent } from './DeleteTimeOffView.component';

export const DeleteTimeOffView: FC = () => {
  return (
    <QuerySwitch
      context={FetchTimeOffDataContext}
      component={() => (
        <DeleteTimeOffViewPropsProvider>
          <DeleteTimeOffViewComponent />
        </DeleteTimeOffViewPropsProvider>
      )}
    />
  );
};
